<div class="alert alert-warning" *ngIf="warnings && (warnings | warningsFilter: warnings.length)?.length">
	<ul class="m-0 list-unstyled">
		<li *ngFor="let warning of warnings">{{ warning }}</li>
	</ul>
</div>
